<template>
  <div class="yxtbiz-audit-workflow-detail" v-loading="loading">
    <div class="detail-flow" v-if="detailInfo">
      <div class="detail-flow-detail">
        <!--开始-->
        <div class="flow-start flow-item">
          <div class="left">
            <div class="icon">
              <img src="https://stc.yxt.com/ufd/2338a3/auditCenter/pc/img/audit-start.png">
            </div>
            <div class="pass-line mt2 mb2"></div>
          </div>
          <div class="right ml23">
            <div class="title mb12 color-gray-10 font-weight-400 font-size-16">{{
                $t('pc_audit_lbl_review').d('发起审核')
              }}
            </div>
            <div class="userinfo font-size-14 lh20 color-gray-9">
              <div class="userinfo-icon">
                <yxtf-portrait class="img" size="small" :username="detailInfo.userName"
                :imgUrl="detailInfo.pic"
                ></yxtf-portrait>
              </div>
              <div class="userinfo-name ml8 ell">
                <!--<yxtbiz-position-name :name="detailInfo.initUser"/>-->
                <yxtbiz-user-name :name="detailInfo.initUser"/>
              </div>
              <div class="userinfo-status ml24">{{ $t('pc_audit_lbl_initiate').d('发起') }}</div>
              <div class="userinfo-punctuation ml5 mr5">.</div>
              <div class="userinfo-time">{{ detailInfo.initTime }}</div>
            </div>

          </div>
        </div>
        <!--审核-->
        <div v-for="item in detailInfo.nodeJson" :key="item.id" class="flow-pass flow-item">
          <div class="left">
            <div class="icon">
              <img :src="getImgUrl(item.auditStatus)">
            </div>
            <div :class="item.auditStatus==0||item.auditStatus===5?'no-pass-line':'pass-line'" class="mt2 mb2">
            </div>
          </div>
          <div class="right ml23 mb16">
            <div class="title mb8 color-gray-10 font-weight-400 font-size-16">
              <span>
                {{
                  $t('pc_audit_lbl_audit').d('审核')
                }}</span>
              <!--一人审核无需显示会签或签-->
              <template v-if="item.taskDetail&&item.taskDetail.length>1">
                <span v-if="item.auditType===1"
                      class="need-all-pass bg-gray-2 pl8 pr8 font-size-12 color-gray-9 ml7">{{
                    $t('pc_audit_all_pass').d('需所有人通过')
                  }}</span>
                <span v-if="item.auditType===0"
                      class="need-all-pass bg-gray-2 pl8 pr8 font-size-12 color-gray-9 ml7">{{
                    $t('pc_audit_one_pass').d('1人通过即可')
                  }}</span>
              </template>
            </div>
            <div v-if="item.auditStatus!==5" :class="getStatusClass(item.auditStatus)" class="mb16">
              {{ getItemStatus(item.auditStatus) }}
            </div>
            <div class="userinfo font-size-14 lh20 color-gray-9 mb15" v-for="innerItem in item.taskDetail"
                :key="innerItem.auditTime">
              <!--用户信息不存在不展示节点信息-->
              <template v-if="innerItem.auditUser">
                <div class="userinfo-icon">
                  <yxtf-portrait class="img" size="small" :username="innerItem.userName"  :imgUrl="innerItem.pic"
                  ></yxtf-portrait>
                </div>
                <div class="userinfo-name ml8 ell">
                  <span>
                      <!--<yxtbiz-position-name :name="innerItem.auditUser"/>-->
                    <yxtbiz-user-name :name="innerItem.auditUser"/>
                  </span>
                </div>
                <div class="userinfo-status ml24" v-if="innerItem.auditStatus!==5">
                  {{ getItemStatus(innerItem.auditStatus) }}
                </div>
                <div class="ml5 mr5" v-show="innerItem.auditTime">.</div>
                <div class="userinfo-time" v-show="innerItem.auditTime">{{ innerItem.auditTime }}</div>
                <div class="userinfo-message" v-if="innerItem.auditDesc">
                  <span class="userinfo-message-title">{{ $t('pc_audit_lbl_auditopinion').d('审核意见') }}：</span>
                  <span class="color-gray-9">
                    <EllipsisText :text="innerItem.auditDesc" />
                  </span>
                </div>
              </template>
            </div>
          </div>
        </div>
        <!--结束-->
        <div class="flow-end flow-item">
          <div class="left">
            <div class="icon">
              <img src="https://stc.yxt.com/ufd/2338a3/auditCenter/pc/img/audit-end-new.png">
            </div>
          </div>
          <div class="right ml23 flow-end-right">
            <div class="title mb12 color-gray-10 font-weight-400 font-size-16">{{
                $t('pc_audit_lbl_end').d('结束')
              }}
            </div>
            <div v-if="detailInfo.auditStatus !== 0" class="color-gray-9">{{ detailInfo.updateTime }}</div>
          </div>
        </div>
      </div>
    </div>
    <yxt-empty v-else img="nodata-new"></yxt-empty>
  </div>
</template>

<script>
import EllipsisText from './ellipsis-text';
import { getTaskDetail } from './service';

const auditTagStatusObj = {
  0: 'pc_biz_te_status_checking', // 审核中
  1: 'pc_biz_lbl_passed', // 已通过
  2: 'pc_biz_te_status_rejected', // 已拒绝
  3: 'pc_audit_global_lbl_undone', // 已撤销
  4: 'pc_auto_pass', // 自动通过
  5: 'pc_audit_global_lbl_no_start', // 未启动
  6: 'pc_audit_global_lbl_not_use' // 账号不可用
};

export default {
  name: 'YxtbizAuditWorkflowDetail',
  components: {
    EllipsisText
  },
  props: {
    formType: {
      type: String,
      default: ''
    },
    formId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      detailInfo: null
    };
  },
  created() {
    this.getTaskDetail();
  },
  methods: {
    async getTaskDetail() {
      this.loading = true;
      this.detailInfo = null;
      try {
        const res = await getTaskDetail({
          formType: this.formType,
          formId: this.formId
        });
        if (res) {
          this.detailInfo = res;
        }
      } catch (error) {
        this.detailInfo = null;
      } finally {
        this.loading = false;
      }
    },
    getStatusClass(status) {
      return status === 0 ? 'status-ing' : status === 2 ? 'status-reject' : 'color-gray-7';
    },
    getItemStatus(status) {
      return this.$t(auditTagStatusObj[status]);
    },
    getImgUrl(status) {
      if (status === 0 || status === 5) {
        return 'https://stc.yxt.com/ufd/2338a3/auditCenter/pc/img/audit-img.png';
      } else {
        return 'https://stc.yxt.com/ufd/2338a3/auditCenter/pc/img/audit-pass.png';
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.detail-flow-detail {
  .flow-start {
    .icon {
      background: #f9bb6a;
    }
  }

  .flow-pass {
    .icon {
      background: #6fb1fb;
    }

    .status-ing {
      color: #fa8c16;
    }

    .status-reject {
      color: #f5222d;
    }
  }

  .flow-end {
    .icon {
      background: #64c8bc;
    }

    .flow-end-right {
      justify-content: center;
    }
  }

  .flow-item {
    display: flex;

    .left {
      display: flex;
      flex-direction: column;
      align-items: center;

      .icon {
        width: 48px;
        height: 48px;
        border-radius: 50%;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .pass-line {
        flex: 1;
        width: 2px;
        min-height: 42px;
        background: rgba(67, 107, 255, 0.6);
      }

      .no-pass-line {
        flex: 1;
        width: 2px;
        min-height: 42px;
        background: #dfdfdf;
      }
    }

    .right {
      display: flex;
      //align-items: center;
      flex-direction: column;
      //justify-content: center;
      .need-all-pass {
        display: inline-block;
        height: 20px;
        line-height: 20px;
      }

      .userinfo {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .userinfo-base {
          display: flex;
          min-width: 260px;
        }

        .userinfo-icon {
          width: 24px;
          height: 24px;

          .img {
            width: 24px;
            height: 24px;
          }
        }

        .userinfo-name {
          max-width: 600px;
        }

        .userinfo-name-status {
          color: #8c8c8b;
        }
        .userinfo-punctuation{
          writing-mode: vertical-lr;
          line-height: 4px;
          height: 4px;
          position: relative;
          left: 4px;
        }
        .userinfo-message {
          margin-top: 12px;
          display: flex;
          width: 100%;

          .userinfo-message-title {
            min-width: 70px;
            color: #8c8c8b;
          }
        }
      }
    }
  }
}
</style>